import { Member } from "@ui/interfaces"

export const getQueryRailsHeaders = (member: Member) => {
  const { id, email, role } = member

  return {
    'x-datable-user-id': id,
    'x-datable-user-role': role,
    'x-datable-user-email': email,
  }
}